import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e627310"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "data-area",
  class: "col-lg-4 col-md-5 col-sm-6 col-xs-12 no-float form-part position-relative"
}
const _hoisted_2 = { class: "data-series-history" }
const _hoisted_3 = { class: "login-form mt-3" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-sm-12" }
const _hoisted_6 = { class: "tiny_bottom_margin size-17rem" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "medium_bottom_margin" }, "managt.byihuse.rw", -1))
const _hoisted_8 = { class: "form-group mb-3" }
const _hoisted_9 = { class: "browser_password align_left" }
const _hoisted_10 = ["placeholder", "disabled"]
const _hoisted_11 = {
  key: 0,
  class: "error-style"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "ladda-label" }
const _hoisted_15 = { class: "align_left small_top_margin size-small-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountHeader = _resolveComponent("AccountHeader")!
  const _component_alert_error = _resolveComponent("alert-error")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AccountHeader),
      (_ctx.isErrorVisible)
        ? (_openBlock(), _createBlock(_component_alert_error, {
            key: 0,
            "error-message": _ctx.errorMessage,
            onOnClose: _ctx.closeAlertError
          }, null, 8, ["error-message", "onOnClose"]))
        : _createCommentVNode("", true),
      _createElementVNode("form", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.language.forgotPassWord), 1),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, [
                _createTextVNode(_toDisplayString(_ctx.language.enterYour) + " ", 1),
                _createElementVNode("strong", null, _toDisplayString(_ctx.language.email.toLocaleLowerCase()), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "email",
                autocomplete: "off",
                class: _normalizeClass(["form-control selectallfocus py-3 mb-2", {'input-error': _ctx.v$.userEmail.$error}]),
                placeholder: _ctx.language.email.toLocaleLowerCase(),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userEmail) = $event)),
                onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.userEmail.$touch && _ctx.v$.userEmail.$touch(...args))),
                disabled: _ctx.isNetLoading
              }, null, 42, _hoisted_10), [
                [_vModelText, _ctx.userEmail]
              ]),
              (_ctx.v$.userEmail.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.v$.userEmail.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("p", null, [
              _createElementVNode("button", {
                disabled: _ctx.v$.$error || _ctx.isFormError,
                type: "button",
                class: "btn btn-success btn-block btn-large",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submitThisForm && _ctx.submitThisForm(...args)))
              }, [
                (_ctx.showLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['fas', 'spinner'],
                        class: "d-inline-block me-1"
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.language.reset), 1)
              ], 8, _hoisted_12)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_RouterLink, { to: "/account/login" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.language.logInInstead), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}